import { render } from "./DeleteTerritoryClassDialog.vue?vue&type=template&id=54630de8"
import script from "./DeleteTerritoryClassDialog.vue?vue&type=script&lang=js"
export * from "./DeleteTerritoryClassDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__